export const SCENE_LIST_FLOOR_LEVELS = [
  '68d1318e208f82c724e18089',
  '68d23c51208f82c724e1b8e3',
  '68d11fb3f1fff2aa8e505189',
  '68d11ff8f1fff2aa8e505326',
  '68d12016f1fff2aa8e50534e',
  '68d12769ddcbe92b6b39ad9e',
];

export const COMPASS_DEGREE_SCENE_DATA = {
  '68d12cca208f82c724e17eb7': 180,
  '68d12e81208f82c724e18004': 170,

  //floors
  // '68d11ff8f1fff2aa8e505326': -80,
  // '68d12769ddcbe92b6b39ad9e': -80,
  // '68d12016f1fff2aa8e50534e': -80,
  // '68d11fb3f1fff2aa8e505189': -80,
  // '68d1318e208f82c724e18089': -80,
  // '68d23c51208f82c724e1b8e3': -80,

  '68d11ff8f1fff2aa8e505326': 70,
  '68d12769ddcbe92b6b39ad9e': 70,
  '68d12016f1fff2aa8e50534e': 70,
  '68d11fb3f1fff2aa8e505189': 70,
  '68d1318e208f82c724e18089': 70,
  '68d23c51208f82c724e1b8e3': 70,
};

export const MENU_ICONS = [
  'icon_menu_toancanh.png',
  'icon_menu_matbang.png',
  'icon_menu_gallery.png',
  'icon_menu_tienich.png',
  'icon_menu_canho.png',
  'icon_menu_vitri.png',
];

export const VISIBILITY_BY_KEY = {
  'floor-plan': { world3D: false, hover: true, map: false, location: false },
  'amenities': { world3D: false, hover: false, map: true, location: false },
  'location': { world3D: false, hover: false, map: false, location: true },
  default: { world3D: true, hover: false, map: false, location: false },
};

export const BLOCKING_KEYS = new Set(['floor-plan', 'amenities', 'location']);
